/**
 * Inspire-hub 2 (www.giap.pl)
 *
 * Copyright © GIAP sp.z.o.o. All rights reserved.
 *
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Written by Krzysztof Gregorowicz <gregorowicz.k@gmail.com>, February 2017
 */

import React from 'react';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import { connect } from 'react-redux';
import { Grid, Row, Col, Button, Popover, OverlayTrigger, FormGroup, FormControl, ControlLabel, Glyphicon } from 'react-bootstrap';
import s from './ServicesHeader.scss';
import logoInspire from './logo.png';
import logoPodlaskie from './logo_ipodlaskie.png';
import { fetchDistrictArms } from '../../actions/eservices';
import { setRuntimeVariable } from '../../actions/runtime';
import { layoutColorStyle, podlaskieMainPageURL, setFooterAndHeaderColors, isMobileView, isTabletView } from '../utils/utils';
import { adminEndpoint, adminRole, analytics, districtAdminRole, portalMode } from '../../config';
import { PODLASKIE_MODE } from '../../constants';

const PZLogin = 'https://e-spdp.pl';

const loginPopup = (
  <Popover id="popover-positioned-bottom" >
    <form method="post">
      <FormGroup controlId="formValidationNull" validationState={null}>
        <ControlLabel>Login</ControlLabel>
        <FormControl type="text" />
      </FormGroup>
      <FormGroup controlId="formValidationNull" validationState={null}>
        <ControlLabel>Hasło</ControlLabel>
        <FormControl type="password" />
      </FormGroup>
      <Button style={{ width: '100%' }} bsStyle="primary" type="submit">
          Zaloguj
      </Button>
    </form>
  </Popover>
);

const maxFontSize = 2.4;
const minFontSize = 0.4;
const fontSizeOffset = 0.2;

class ServicesHeader extends React.Component {
  state = {
    // herb: null,
    redirectURL: '/',
    ariaExpanded: false,
    showMobileMenu: false,
    colors: 'normal',
    sourceStyle: layoutColorStyle,
    style: {},
    isMounted: false,
    matomoSiteId: null,
  }
  redirectURL = '/'

  constructor(props) {
    super(props);
  }

  componentDidMount() {
    this.setTheme();
    if (this.props.prefix !== undefined) {
      this.props.fetchDistrictArms(this.props.prefix);
    }
    if (this.props.user && !this.props.user.loginConfirmed && !window.location.href.includes('/panel/') && !window.location.href.includes('/registerwk')){
      window.location.href = `/panel/${this.props.user.username}?href=${encodeURIComponent(`${window.location.pathname}${window.location.search}`)}`;
    }
    this.setState({ isMounted: true }, () => {
      if (!window.googleTranslateElementInit) {
        window.googleTranslateElementInit = this.googleTranslateElementInit;
        this.addGoogleTranslate();
      }
    });

    window.addEventListener("pageshow", (event) => {
      if (event.persisted) {
        if (document.getElementById("google_translate_element")) {
          window.googleTranslateElementInit();
        }
      }
    });
  }

  componentDidUpdate() {
    if (this.props.districts) {
      const districtPath = /\/urzad\/(\w+)/.exec(window.location.pathname);
      const currentPrefix = districtPath ? districtPath[1] : null;
      const queryParams = new URLSearchParams(window.location.search);
      const currentTeryt = queryParams.get('district');

      const districtSettings = Object.values(this.props.districts)
        .find(districtData => districtData.prefix === currentPrefix
          || districtData.teryt == currentTeryt
        );

      if (districtSettings) {
        const matomoSiteId = districtSettings.matomoSiteId;
  
        if (matomoSiteId !== this.state.matomoSiteId) {
          if (matomoSiteId) {
            this.addMatomo(matomoSiteId);
          }
          this.setState({matomoSiteId: matomoSiteId});
        }
      }
    }
  }

  addGoogleTranslate() {
    const existingScript = Array.from(document.scripts).some(script =>
      script.src.includes("translate.google.com/translate_a/element.js")
    );

    if (!existingScript) {
      const addScript = document.createElement("script");
      addScript.src =
        "https://translate.google.com/translate_a/element.js?cb=googleTranslateElementInit";
      addScript.async = true;
      document.body.appendChild(addScript);
    }
  }

  googleTranslateElementInit = () => {
    if (window.google && window.google.translate) {
      new window.google.translate.TranslateElement({
        pageLanguage: 'pl',
        includedLanguages: 'pl,en,de,uk',
      }, 'google_translate_element');
    }
  };

  addMatomo(matomoSiteId) {
    const matomoURL = analytics.matomo.apiURL;
    const matomoScriptSRC = `${matomoURL}matomo.js`;
    const paq = window._paq = window._paq || [];
    /* tracker methods like "setCustomDimension" should be called before "trackPageView" */
    paq.push(['trackPageView']);
    paq.push(['enableLinkTracking']);
    paq.push(['setTrackerUrl', `${matomoURL}matomo.php`]);
    paq.push(['setSiteId', matomoSiteId]);

    const matomoScriptElement = document.createElement('script');
    const firstScriptElement = document.getElementsByTagName('script')[0];
    matomoScriptElement.async = true;
    matomoScriptElement.src = matomoScriptSRC;
    firstScriptElement.parentNode.insertBefore(
      matomoScriptElement, firstScriptElement);
  }

  setTheme() {
    const {colors, sourceStyle, style} = setFooterAndHeaderColors();
    this.setState({ colors, sourceStyle, style});
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.prefix !== undefined && nextProps.prefix !== this.props.prefix) {
      this.props.fetchDistrictArms(nextProps.prefix);
      // fetchArms(nextProps.prefix).then(resp => {
      //   this.setState({ herb: resp });
      // });
    }
  }
  viewMobileMenu = () => {
    this.setState({ showMobileMenu: !this.state.showMobileMenu });
  }

  nazwaUrzedow = () => {
    let gmina;
    for (let key in this.props.districts) {
      if (this.props.districts[key].prefix === this.props.prefix){
        gmina = this.props.districts[key].placeOfSettling;
      }
    }
    return gmina;
  }

  increaseFontSize = e => {
    e.preventDefault();
    const increasedFontSize = parseFloat(this.props.fontSize) + fontSizeOffset;
    if (increasedFontSize <= maxFontSize) {
      document.cookie = `fontSize=${increasedFontSize}`;
      this.props.setRuntimeVariable({ name: 'fontSize', value: increasedFontSize });

    }
  };
  resetFontSize = e => {
    e.preventDefault();
    const defaultFontSize = 1.4;
    document.cookie = `fontSize=${defaultFontSize}`;
    this.props.setRuntimeVariable({ name: 'fontSize', value: defaultFontSize });
  };
  decreaseFontSize = e => {
    e.preventDefault();
    const decreasedFontSize = parseFloat(this.props.fontSize) - fontSizeOffset;
    if (decreasedFontSize >= minFontSize) {
      document.cookie = `fontSize=${decreasedFontSize}`;
      this.props.setRuntimeVariable({ name: 'fontSize', value: decreasedFontSize });
    }
  };

  toggleTranslator = () => {
    const element = document.getElementById("google_translate_element");
  
    if (element) {
      if (!window.google || !window.google.translate) {
        window.googleTranslateElementInit = this.googleTranslateElementInit;
        this.addGoogleTranslate();
      } else {
        this.googleTranslateElementInit();
      }

      element.style.display = element.style.display === "none" ? "block" : "none";
    }
  };

  renderFontSizing = (isMobile) => {
    return (
      <ul className={`nav navbar-nav ${isMobile ? 'mobile-center' : ''}`}>
        <li className="eus-resize" style={{ paddingLeft: isMobile ? '0px' : 'auto' }}>
          <div
            onClick={this.increaseFontSize}
            title='Zwiększ czcionkę'
          >
            <strong>A+&nbsp;</strong>
          </div>
          <div
            onClick={this.resetFontSize}
            title='Resetuj rozmiar czcionki'
          >
            <strong>A&nbsp;&nbsp;</strong>
          </div>
          <div
            onClick={this.decreaseFontSize}
            title='Zmniejsz czcionkę'
          >
            <strong>A-&nbsp;</strong>
          </div>
          <div
            onClick={() => { this.props.setColors('normal'); }}
            style={{ marginLeft: '5px', border: '3px solid grey' }}
            className="glyphicon glyphicon-text-background"
          />
          <div
            onClick={() => { this.props.setColors('intenseBlack'); }}
            style={{ marginLeft: '5px', color: 'black', background: 'white', border: '3px solid grey' }}
            className="glyphicon glyphicon-text-background"
          />
          <div
            onClick={() => { this.props.setColors('intenseBlackYellow'); }}
            style={{ marginLeft: '5px', color: 'black', background: 'yellow', border: '3px solid grey' }}
            className="glyphicon glyphicon-text-background"
          />
          <div
            onClick={() => { this.props.setColors('intenseYellowBlack'); }}
            style={{ marginLeft: '5px', color: 'yellow', background: 'black', border: '3px solid grey' }}
            className="glyphicon glyphicon-text-background"
          />
          <div
            onClick={this.toggleTranslator}
            style={{ 
              marginLeft: '5px',
              display: 'inline-block', 
              cursor: 'pointer',
              width: '36px',
              height: '36px',
            }}
            title="Przetłumacz"
            className="fa fa-globe"
          >
          </div>
        </li>
      </ul>
    )
  }

  renderUser = (isMobile) => {
    if (this.props.user) {
      return (
        <ul className={`nav navbar-nav ${isMobile ? 'mobile-inline' : ''}`}>
          {!this.props.user.isConnectedToPZ ?
            <li><a href="/connectPZ" style={this.state.style}>Połącz z PZ</a></li> : null }
          <li>
            <a
              className={isMobile ? 'username-container' : ''}
              href={`/panel/${this.props.user.username}`}
              style={this.state.style}
              title="Przejdź do Profilu"
            >
              {this.props.user.username}
            </a>
          </li>
          
          { portalMode == PODLASKIE_MODE ?

          <li><button className="btn btn-primary" href="/logout" style={{marginTop: '18px', marginLeft: '10px'}}>Wyloguj</button></li>
          : <li><a href="/logout" style={this.state.style}>Wyloguj</a></li>
          }
        </ul>
      )};

    return null;
  }

  renderStandardHeader () {
    return (
      <div>
      {this.props.prefix ?
        <div className="col-sm-12 col-md-4 eus-logo">
          {this.props.arms ? <img className="herb-gmina" src={`https://e-spdp.pl/oldihub/upload/herby/${this.props.arms}`} alt="herb gminy" /> : null}
          <h2 className="title-gmina">{this.props.prefix ? this.nazwaUrzedow() : null}</h2>
        </div>
         :
        <div className="col-xs-12 col-sm-2 eus-logo">
          <img className="logo-inspire" src={portalMode == PODLASKIE_MODE ? logoPodlaskie : logoInspire} alt="Inspire-hub" />
        </div>}
        <div className="mobile-btn hidden-sm hidden-md hidden-lg hidden-xl col-xs-12 perfect-center" onClick={this.viewMobileMenu}><Glyphicon glyph="menu-hamburger" /></div>
      </div>
    )
  }

  renderMobileHeader () {
    return (
      <div className={'eus-logo-container mobile-inline'}>
        {this.props.prefix ? (
          <div className="col-sm-12 col-md-4 eus-logo">
            {this.props.arms ? (
              <img
                className="herb-gmina"
                src={`https://e-spdp.pl/oldihub/upload/herby/${this.props.arms}`}
                alt="herb gminy"
              />
            ) : null}
            <h2 className="title-gmina">{this.props.prefix ? this.nazwaUrzedow() : null}</h2>
          </div>
        ) : (
          <div className="col-xs-12 col-sm-2 eus-logo">
            <img
              className="logo-inspire"
              src={portalMode === PODLASKIE_MODE ? logoPodlaskie : logoInspire}
              alt="Inspire-hub"
            />
          </div>
        )}
        <div
          className="mobile-btn col-xs-2 perfect-center"
          onClick={this.viewMobileMenu}
        >
          <Glyphicon glyph="menu-hamburger" />
        </div>
      </div>
    )
  }

  renderStandardMenu () {
    const districtsCount = Object.keys(this.props.districts).length;
    return (
      <div className={`navbar zeroH mobile-top-nav ${!this.state.showMobileMenu ? '' : 'show-mobile'}`} style={{ marginBottom: '0' }}>
        <div className="col-xs-12 col-sm-3 navbar-collapse menu-glowne">
          <ul className="nav navbar-nav">
            <li><a href={portalMode == PODLASKIE_MODE ? podlaskieMainPageURL : "/"} className={this.props.active === "main" ? "active" : ""} style={this.state.style}>Strona Główna</a></li>
            {portalMode == PODLASKIE_MODE ?
              <li>
                <a
                  href={"/"}
                  className={this.props.active === "catalogue" ? "active" : ""} 
                  style={this.state.style}>
                  Katalog E-USŁUG
                </a>
              </li>
            :
              <li>
                <a
                  href={districtsCount > 1 ? "/euslugi" : `/urzad/${this.props.districts[Object.keys(this.props.districts)[0]].prefix}`}
                  className={this.props.active === "catalogue" ? "active" : ""}
                  style={this.state.style}
                >
                  Katalog E-USŁUG
                </a>
              </li>
            }
            
            
            { portalMode != PODLASKIE_MODE && districtsCount > 1 ?
              <li><a href="/urzad" className={this.props.active === "district" ? "active" : ""}  style={this.state.style}>Urzędy</a></li>
              : null
            }
            {this.props.prefix === 'gmina_cieszanow' ?
            <li><a href="/gmina_cieszanow" style={this.state.style}>Mapa</a></li>
            : null }
            {this.props.prefix === 'gmina_grodzisko_dolne' ?
            <li><a href="http://mapa.inspire-hub.pl/#/gmina_grodzisko_dolne" style={this.state.style}>Mapa</a></li>
            : null }
            {this.props.user && this.props.user.roles && this.props.user.roles.indexOf(adminRole) >= 0 ?
              <li className="dropdown" style={this.state.style} onMouseEnter={() => this.setState({ ariaExpanded: true })} onMouseLeave={() => this.setState({ ariaExpanded: false })}>
                <a href="#" className="dropdown-toggle" style={this.state.style} onClick={() => this.setState({ ariaExpanded: !this.state.ariaExpanded })}>Admin
                  <span className="caret"></span></a>
                <ul className="dropdown-menu" style={{ ...this.state.style,display: this.state.ariaExpanded ? 'block': 'none'}}>
                  <li><a href={`${adminEndpoint}/districts`} style={this.state.style}>Gminy</a></li>
                  <li><a href={`${adminEndpoint}/users`} style={this.state.style}>Użytkownicy</a></li>
                  <li><a href={`${adminEndpoint}/claims`} style={this.state.style}>Dokumenty</a></li>
                  <li role="separator" className="divider" style={this.state.style}></li>
                  <li><a href={`${adminEndpoint}/available_services`} style={this.state.style}>Dostępne e-usługi</a></li>
                  <li><a href={`${adminEndpoint}/service_cards`} style={this.state.style}>Karty e-usług</a></li>
                  <li><a href={`${adminEndpoint}/service_creator`} style={this.state.style}>Kreator e-usług</a></li>
                  <li><a href={`${adminEndpoint}/district_declarations`} style={this.state.style}>Deklaracje dostępności</a></li>
                  <li role="separator" className="divider" style={this.state.style}></li>
                  <li><a href={`${adminEndpoint}/update_emuia`} style={this.state.style}>Aktualizacja EMUIA</a></li>
                </ul>
              </li>
            : null
            }
            {this.props.user && this.props.user.roles && this.props.user.roles.indexOf(districtAdminRole) >= 0 ?
              <li className="dropdown" style={this.state.style} onMouseEnter={() => this.setState({ ariaExpanded: true })} onMouseLeave={() => this.setState({ ariaExpanded: false })}>
                <a
                  href="#"
                  className="dropdown-toggle"
                  style={this.state.style}
                  onClick={() => this.setState({ ariaExpanded: !this.state.ariaExpanded })}
                >
                  Admin
                  <span
                    className="caret"
                    style={this.state.style}
                  />
                </a>
                <ul className="dropdown-menu" style={{ ...this.state.style, display: this.state.ariaExpanded ? 'block' : 'none' }}>
                  <li><a href={`${adminEndpoint}/service_cards`} style={this.state.style}>Karty e-usług</a></li>
                  <li><a href={`${adminEndpoint}/service_creator`} style={this.state.style}>Kreator e-usług</a></li>
                  <li><a href={`${adminEndpoint}/district_declarations`} style={this.state.style}>Deklaracje dostępności</a></li>
                  <li><a href={`/panel/${this.props.user.username}/statusgmin`} style={this.state.style}>Status gminy</a></li>
                </ul>
              </li>
            : null
            }
          </ul>
        </div>
        <div className="col-xs-12 col-sm-3 navbar-collapse logowanie">
          {this.renderFontSizing(false)}
          {this.renderUser(false)}
        </div>
      </div>
    )
  }

  renderMobileMenu () {
    const districtsCount = Object.keys(this.props.districts).length;
    return (
      <div className={`navbar zeroH mobile-top-nav ${!this.state.showMobileMenu ? '' : 'show-mobile'}`} style={{ marginBottom: '0' }}>
        <div className="col-xs-12 col-sm-3 navbar-collapse menu-glowne">
          <ul className="nav navbar-nav">
            <li><a href={portalMode == PODLASKIE_MODE ? podlaskieMainPageURL : "/"} className={this.props.active === "main" ? "active" : ""} style={this.state.style}>Strona Główna</a></li>
            {portalMode == PODLASKIE_MODE ?
              <li>
                <a
                  href={"/"}
                  className={this.props.active === "catalogue" ? "active" : ""} 
                  style={this.state.style}>
                  Katalog E-USŁUG
                </a>
              </li>
            :
              <li>
                <a
                  href={districtsCount > 1 ? "/euslugi" : `/urzad/${this.props.districts[Object.keys(this.props.districts)[0]].prefix}`}
                  className={this.props.active === "catalogue" ? "active" : ""}
                  style={this.state.style}
                >
                  Katalog E-USŁUG
                </a>
              </li>
            }
            { portalMode != PODLASKIE_MODE && districtsCount > 1 ?
              <li><a href="/urzad" className={this.props.active === "district" ? "active" : ""}  style={this.state.style}>Urzędy</a></li>
              : null
            }
            {this.props.prefix === 'gmina_cieszanow' ?
            <li><a href="/gmina_cieszanow" style={this.state.style}>Mapa</a></li>
            : null }
            {this.props.prefix === 'gmina_grodzisko_dolne' ?
            <li><a href="http://mapa.inspire-hub.pl/#/gmina_grodzisko_dolne" style={this.state.style}>Mapa</a></li>
            : null }
            {this.props.user && this.props.user.roles && this.props.user.roles.indexOf(adminRole) >= 0 ?
              <li className="dropdown" style={this.state.style} onMouseEnter={() => this.setState({ ariaExpanded: true })} onMouseLeave={() => this.setState({ ariaExpanded: false })}>
                <a href="#" className="dropdown-toggle" style={this.state.style} onClick={() => this.setState({ ariaExpanded: !this.state.ariaExpanded })}>Admin
                  <span className="caret"></span></a>
                <ul className="dropdown-menu" style={{ ...this.state.style,display: this.state.ariaExpanded ? 'block': 'none'}}>
                  <li><a href={`${adminEndpoint}/districts`} style={this.state.style}>Gminy</a></li>
                  <li><a href={`${adminEndpoint}/users`} style={this.state.style}>Użytkownicy</a></li>
                  <li><a href={`${adminEndpoint}/claims`} style={this.state.style}>Dokumenty</a></li>
                  <li role="separator" className="divider" style={this.state.style}></li>
                  <li><a href={`${adminEndpoint}/available_services`} style={this.state.style}>Dostępne e-usługi</a></li>
                  <li><a href={`${adminEndpoint}/service_cards`} style={this.state.style}>Karty e-usług</a></li>
                  <li><a href={`${adminEndpoint}/service_creator`} style={this.state.style}>Kreator e-usług</a></li>
                  <li><a href={`${adminEndpoint}/district_declarations`} style={this.state.style}>Deklaracje dostępności</a></li>
                  <li role="separator" className="divider" style={this.state.style}></li>
                  <li><a href={`${adminEndpoint}/update_emuia`} style={this.state.style}>Aktualizacja EMUIA</a></li>
                </ul>
              </li>
            : null
            }
            {this.props.user && this.props.user.roles && this.props.user.roles.indexOf(districtAdminRole) >= 0 ?
              <li className="dropdown" style={this.state.style} onMouseEnter={() => this.setState({ ariaExpanded: true })} onMouseLeave={() => this.setState({ ariaExpanded: false })}>
                <a
                  href="#"
                  className="dropdown-toggle"
                  style={this.state.style}
                  onClick={() => this.setState({ ariaExpanded: !this.state.ariaExpanded })}
                >
                  Admin
                  <span
                    className="caret"
                    style={this.state.style}
                  />
                </a>
                <ul className="dropdown-menu" style={{ ...this.state.style, display: this.state.ariaExpanded ? 'block' : 'none' }}>
                  <li><a href={`${adminEndpoint}/service_cards`} style={this.state.style}>Karty e-usług</a></li>
                  <li><a href={`${adminEndpoint}/service_creator`} style={this.state.style}>Kreator e-usług</a></li>
                  <li><a href={`${adminEndpoint}/district_declarations`} style={this.state.style}>Deklaracje dostępności</a></li>
                  <li><a href={`/panel/${this.props.user.username}/statusgmin`} style={this.state.style}>Status gminy</a></li>
                </ul>
              </li>
            : null
            }
          </ul>
        </div>
        <div className="col-xs-12 col-sm-3 navbar-collapse logowanie">
          {this.renderUser(true)}
          {this.renderFontSizing(true)}
        </div>
      </div>
    )
  }

  render() {
    let isMobile = false;
    let isTablet = false;
    if (this.state.isMounted) {
      isMobile = isMobileView(window);
      isTablet = isTabletView(window);
    }

    return (
      <Grid fluid>
        <Row>
          <Col xs={12} className="no-padding" style={this.state.style}>
            <header className={`eus-bckgr`}>
              { isMobile || isTablet ?
                this.renderMobileHeader()
              :
                this.renderStandardHeader()
              }

              { isMobile || isTablet ?
                this.renderMobileMenu()
              :
                this.renderStandardMenu()
              }

              {this.props.prefix !== undefined && this.props.prefix === 'gmina_wieliszew' ?
                <div className="col-lg-12">
                  <Row>
                    <Col xs={3} />
                    <Col xs={6} style={{ paddingTop: '5px', paddingBottom: '5px' }}>
                      <img
                        alt="Stopka"
                        src={
                          this.props.districts && Object.keys(this.props.districts)
                            .filter(urzad => urzad === this.props.prefix)
                            .map(urzad => this.props.districts[urzad].footerLogo,
                          )
                        }
                        width={'100%'}
                      />
                    </Col>
                    <Col xs={3} />
                  </Row>
                </div>
                  : null}
            </header>
          </Col>
        </Row>
        <Row style={{ textAlign: 'right' }}>
          <div id="google_translate_element" style={{ paddingRight: '20px', display: 'none', ...this.state.style }}></div>
        </Row>
        {/* <Row style={{ backgroundColor: 'red' }}>
          <p style={{ color: 'white', marginBottom: '10px', marginTop: '10px', textAlign: 'center' }}>
            <b>
              W związku z pracami modernizacyjnymi, bramka płatnicza Blue Media będzie niedostępna z 15 na 16 stycznia 2022 r. (sobota/niedziela), w godzinach 23.00-5.00, co uniemożliwi zlecanie płatności online. Zachęcamy do złożenie zamówienia po godzinie 5:00. Przepraszamy za utrudnienia.
            </b>
          </p>
        </Row> */}
      </Grid>
    );
  }
}
const mapState = (state) => ({
  user: state.user,
  arms: state.eservices.arms,
  districts: state.district.districts,
  eservices: state.district.eservices,
  isAllDistrictFetched: state.district.isAllDistrictFetched,
  isServicesFetched: state.district.isServicesFetched
});
const mapDispatch = {
  fetchDistrictArms,
  setRuntimeVariable,
};

export default withStyles(s)(connect(mapState, mapDispatch)(ServicesHeader));



// WEBPACK FOOTER //
// src/components/ServicesHeader/ServicesHeader.js